const integration = {
  PIX_KEY_REGISTERED_IN_SOMEONE_ELSES_NAME: {
    message: 'PIX key registered to someone else.',
    code: 'INT_1'
  },
  PIX_KEY_REGISTERED_AT_ANOTHER_INSTITUTION: {
    message: 'PIX key registered at another institution.',
    code: 'INT_2'
  },
  PIX_KEY_IN_CLAIM_PROCESS: {
    message: 'PIX key in claim process.',
    code: 'INT_3'
  },
  CLAIM_ALREADY_EXISTS_FOR_KEY: {
    message: 'Claim already exists for key.',
    code: 'INT_4'
  }
};

module.exports = integration;
